import { INotice } from 'store/features/application/types/notice';
import slice from '../reducer/slice';

type TOperation = ({ id }: Pick<INotice, 'id'>) => void;

const { resetNotice } = slice.actions;

const operation: TOperation = (props) => resetNotice(props);

export default operation;
